import React from 'react';
import { FormattedMessage } from 'react-intl';
import classes from './styles.module.css';

const Empty = () => {
    return (
        <tr className={classes.EmptyRow}>
            <td colSpan="6">
                <div className={classes.Empty}>
                    <h5>
                        <FormattedMessage id="PayoutsTable.empty" defaultMessage="Нет данных удовлетворяющих фильтрам" />
                    </h5>
                </div>
            </td>
        </tr>
    );
};

export default Empty;



// WEBPACK FOOTER //
// ./src/Components/PayoutsTable/Empty.js